import { Container, Divider, Grid, IconButton, Typography } from "@material-ui/core";
import React, { useContext, useEffect, useState } from "react";
import SectionTile from "../../components/SectionTile/SectionTile";
import SyncIcon from "@material-ui/icons/Sync";
import "./SectionPage.css";
import { TestContext } from "../../contexts/TestContext";
import { UserContext } from "../../contexts/UserContext";
import axios from "axios";

const SectionPage = (props) => {
	const [disabled, setDisabled] = useState(false);
	const [error, setError] = useState(false);
	const [attempted, setAttempted] = useState(0);
	const { autoLogOut } = useContext(UserContext);
	const { timer, endTest, setRemainingTime, setOpenTime } = useContext(TestContext);

	const refresh = () => {
		setDisabled(false);
		setError(false);
		setAttempted(0);
		getNumber();
	};

	const getNumber = async () => {
		const url = `${process.env.REACT_APP_BACKEND_URL}/user/numberAttempted`;
		const token = localStorage.getItem("token");
		try {
			await axios
				.get(url, {
					headers: {
						Authorization: `Bearer ${token}`,
					},
				})
				.then((res) => {
					// console.log(res);
					setAttempted(res.data.numberOfResponses + res.data.numberOfsectionD);
				});
		} catch (error) {
			// console.log(error);
			if (error.response.status === 420) {
				autoLogOut();
			}
		}
	};

	useEffect(() => {
		// if (!props.location.state) {
		// setError(true);
		const date = new Date("2021-08-20T13:30:00.000Z").getTime();
		setOpenTime(Date.now());
		setRemainingTime(date - Date.now());
		// } else {
		// 	setOpenTime(props.location.state.openTime);
		// 	setRemainingTime(props.location.state.time);
		// }
		getNumber();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	if (error) {
		return "There was some error. Please start the test again from the dashboard.";
	}

	return (
		<>
			<Container className="sections-page">
				<div style={{ height: "100%" }}>
					<div
						style={{
							display: "flex",
							alignItems: "center",
							padding: "8px",
						}}
					>
						<h1 style={{ flex: 1 }}>Select a section to start test</h1>
						{timer}
					</div>
					<Divider />
					<Typography variant="h5" style={{ textAlign: "center", width: "100%" }}>
						<strong>Attempted:</strong>{" "}
						<span style={{ color: "#f4792a", fontWeight: "bold" }}>{attempted}</span> of{" "}
						<span style={{ color: "#107be5", fontWeight: "bold" }}>155</span>
						<IconButton aria-label="refresh" onClick={refresh}>
							<SyncIcon />
						</IconButton>
					</Typography>
					<Grid
						container
						spacing={3}
						className="sections-grid-container"
						justify="center"
					>
						<Grid item xs={12} sm={6} className="section-grid-item">
							<SectionTile
								title="SECTION A"
								task="English Grammer"
								description="(14 Questions)"
								section="A"
								disabled={disabled}
								setDisabled={setDisabled}
							/>
						</Grid>
						<Grid item xs={12} sm={6} className="section-grid-item">
							<SectionTile
								title="SECTION B"
								task="Cognitive"
								description="(20 Questions)"
								section="B"
								disabled={disabled}
								setDisabled={setDisabled}
							/>
						</Grid>
						<Grid item xs={12} sm={6} className="section-grid-item">
							<SectionTile
								title="SECTION C"
								task="Case Analysis"
								description="(69 Questions)"
								section="C"
								disabled={disabled}
								setDisabled={setDisabled}
							/>
						</Grid>
						<Grid item xs={12} sm={6} className="section-grid-item">
							<SectionTile
								title="SECTION D"
								task="Spoken English"
								description="(18 Questions)"
								section="D"
								disabled={disabled}
								setDisabled={setDisabled}
								sectionD
							/>
						</Grid>
						<Grid item xs={12} sm={6} className="section-grid-item">
							<SectionTile
								title="SECTION E"
								task="Personality Profiler"
								description="(34 Questions)"
								section="E"
								disabled={disabled}
								setDisabled={setDisabled}
							/>
						</Grid>
						<Grid item xs={12} style={{ display: "flex", justifyContent: "center" }}>
							{endTest}
						</Grid>
					</Grid>
				</div>
			</Container>
		</>
	);
};

export default SectionPage;
